import { Environment } from '@anyx/shared-utils';

export const ANYCHAT_API_HOST: Partial<Record<Environment, string>> = {
  [Environment.LOCAL]: 'https://api.stg.anychat.tech/api',
  [Environment.STAGING]: 'https://api.stg.anychat.tech/api',
  [Environment.PRODUCTION]: 'https://api.anychat.tech/api',
};

export const AI_AUTO_REPLY_API_HOST: Partial<Record<Environment, string>> = {
  [Environment.LOCAL]: 'https://api.stg.anychat.tech/prompts',
  [Environment.STAGING]: 'https://api.stg.anychat.tech/prompts',
  [Environment.PRODUCTION]: 'https://api.anychat.tech/prompts',
};

/** AnyTag's admin app, where CS adds an influencer missing from AnyTag (AnyMindGroup/anychat#378) */
export const ANYTAG_APP_HOST: Partial<Record<Environment, string>> = {
  [Environment.LOCAL]: 'https://stg-app.anytag.jp',
  [Environment.PREVIEW]: 'https://stg-app.anytag.jp',
  [Environment.STAGING]: 'https://stg-app.anytag.jp',
  [Environment.PRODUCTION]: 'https://app.anytag.jp',
};
